/**
 * Class description
 *
 * Created: 2019-08-29
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {HarlequinBackground} from "../background/HarlequinBackground";

export class NormalWin implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;
    private _hasWin:boolean;
    private _winRatio:number;
    private _lastNormalWinConfig:IWinRatioConfig;
    private _tl:Timeline;
    private _mode:string;

    constructor(lastNormalWinConfig:IWinRatioConfig, stagger?:number, abortStagger?:number) {
        this._lastNormalWinConfig = lastNormalWinConfig;
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:ParsedGameData):void {
        const harleyData:HarlequinParsedGameData = <HarlequinParsedGameData> data;
        this._hasWin =  data.singleWin > 0 && !data.isBigWin;
        this._winRatio = harleyData.singleWin/harleyData.playedBetValue;
        this._mode = data.mode;

        /*
        if(!data.currentWinRatioConfig && data.singleWin <= 0) {
            return;
        }

        this._hasWin = true;
        let config:IWinRatioConfig = data.currentWinRatioConfig!;
        if(data.currentWinRatio > this._lastNormalWinConfig.ratio) {
            config = this._lastNormalWinConfig;
        }

        this._countFrom = 0;
        this._countTo = data.playedBetValue * config.ratio;
        this._duration = config.duration * 3;
        this._sound = config.sound!;*/
    }

    public getAnimation(data:HarlequinParsedGameData):Timeline | null {
        if(!this._hasWin) {
            return null;
        }

        //debugger;
        const countStart:TimelineLite = HarlequinGameModuleConfig.countUpView.getWinStepAnimation(0, data.singleWin, data.currentWinRatioConfig!.duration, undefined, this._winRatio);

        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            //Sound.playEffect(data.currentWinRatioConfig!.sound!)
        });
        tl.add(countStart);
        if(this._mode === "NORMAL") {
            tl.add(() => (<HarlequinBackground> HarlequinGameModuleConfig.background).playBgSpine("basegame"));
        }
        // TODO: Ugly compensation duration add
        //tl.add(() => {}, "+=0.5");

        this._tl = tl;
        return this._tl;
    }

    public abort(isActive:boolean, data:ParsedGameData):Timeline | null {
        if(isActive && this._tl) {
            return this._tl;
            //this.getAnimation(<HarlequinParsedGameData> data);
            //GameRoundManager.detachAndPlayTimeline(this._tl);
        }
        else {
            if(this._hasWin) {
                return this.getAnimation(<HarlequinParsedGameData> data);
            }
        }
        return null;
    }

    /*

        public abort(isActive:boolean, data:ParsedServerData):Timeline | null {
            const tl:TimelineLite = new TimelineLite();
            tl.add(new TweenLite(this, 1, {}));
            return tl;
        }
    */

}